module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_sekundaerlogo_postale_pos.8bb1b2da.pdf";